import React from "react";

// STYLES
import {
  LegislationSectionContainer,
  Container,
  Card,
  SVGWrapper,
  TextWrapper,
  SvgBackground,
} from "./LegislationSectionStyled";

// LIBRARIES
import { useNavigate } from "react-router";

//ASETS

import { ReactComponent as QuarterCircle } from "assets/svg/QuarterCircle.svg";

// // MISC

import { useLegislationCards } from "./LegislationSectionModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";

//REDUX

import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS

import CustomText from "components/Atoms/CustomText/CustomText";

// CONFIGURATION

const LegislationSection = () => {
  // PROPERTIES

  // API REQUESTS

  // The tabs for the menu

  // Function to handle tab selection

  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS
  const legislationCards = useLegislationCards();
  // LIFE CYCLE

  // EVENT HANDLERS
  const handleNavigateCard = (route: string) => {
    navigate(route);
  };

  return (
    <LegislationSectionContainer>
      <SvgBackground>
        <QuarterCircle />
      </SvgBackground>
      <Container>
        {legislationCards.map((card) => (
          <Card
            key={card.id}
            backgroundColor={card.backgroundColor}
            textColor={card.textColor}
            gridArea={card.gridArea}
            biggerCursor={biggerCursor}
            onClick={() => handleNavigateCard(card.route)}
          >
            <SVGWrapper
              position={card.svgPosition}
              transform={card.svgTransform}
              opacity={card.svgOpacity}
              height={card.height}
            >
              {card.svg}
            </SVGWrapper>
            <TextWrapper placement={card.textPlacement}>
              {card.title.split("\n").map((line, index) => (
                <CustomText key={index} text={line} type={TextType.H3} />
              ))}
            </TextWrapper>
          </Card>
        ))}
      </Container>
    </LegislationSectionContainer>
  );
};

export default LegislationSection;
